import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  --bgColor: transparent;
  --fgColor: ${brand.white};
  --tintColor: rgba(0, 0, 0, 0.7);
  --buttonSize: ${fluid(18, 35)};
  --gutter: 75px;

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  color: var(--fgColor);
  height: 100%;
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: ${Layers.Modal};

  &[data-open='false'] {
    display: none;
  }
`;
const Inner = styled.div `
  position: relative;

  @media ${from(Device.TabletLarge)} {
    margin: var(--gutter) 0;

    > video,
    > img {
      max-height: calc(100vh - (var(--gutter) * 2));
    }
  }
`;
const ModalStyles = {
    Container,
    Inner,
};
export default ModalStyles;
